import { createStyles, ThemeColors } from 'core/utilities/theme';

export default createStyles({
  root: {
    display: 'flex',
  },
  sidebar: {
    position: 'relative',
    zIndex: 2,
    display: 'inline-block',
    borderRight: `1px solid ${ThemeColors.sequenceAnalyserBorder}`,
    paddingLeft: '8px',
    background: 'white',
    transformOrigin: '0 0',
    borderTop: `1px solid ${ThemeColors.sequenceAnalyserBorder}`,
  },
  content: {
    position: 'relative',
    display: 'inline-block',
    textAlign: 'center',
    background: 'white',
    borderTop: `1px solid ${ThemeColors.sequenceAnalyserBorder}`,
  },
});
